<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field label="Date">
              <b-datepicker
                v-model="date"
                name="date"
                :first-day-of-week="1"
                :locale="'en-CA'"
                icon="calendar-alt"
                placeholder="Date"
              />
            </b-field>
            <b-field v-if="user.group.plants && user.group.plants.length != 0" label="Plant">
              <b-select v-model="selectedPlant" icon="industry" expanded>
                <option v-for="plant in user.group.plants" :key="plant.id" :value="plant">
                  {{ plant.name }}
                </option>
              </b-select>
            </b-field>
            <b-field v-else label="Plant">
              <multiselect
                v-model="selectedPlant"
                :options="plants"
                :multiple="false"
                :close-on-select="true"
                placeholder="Pick plant"
                :custom-label="(obj) => obj.id + ' - ' + obj.name"
                track-by="name"
                style="min-width: 400px;"
              />
            </b-field>
          </b-field>
          <b-field>
            <b-button
              class="left-right"
              type="is-warning"
              icon-left="arrows-rotate"
              :disabled="isLoading || selectedPlant === null"
              @click="() => {resetData(); getData();}"
            >
              Load
            </b-button>
          </b-field>
          <b-tabs v-model="activeTab" type="is-toggle" expanded>
            <b-tab-item
              v-for="stock in crateStocks"
              :key="stock.type"
              :value="stock.type"
              :label="stock.type"
              class="card p-3"
            >
              <b-field
                grouped
              >
                <b-field label="Dirty">
                  {{ stock.stocks.find(x => x.status_crates === 'DIRTY').num_crates }}
                </b-field>
                <b-field label="Clean">
                  {{ stock.stocks.find(x => x.status_crates === 'CLEAN').num_crates }}
                </b-field>
                <b-field label="Repair">
                  {{ stock.stocks.find(x => x.status_crates === 'REPAIR').num_crates }}
                </b-field>
              </b-field>
              <b-field grouped>
                <b-field label="Received Dirty">
                  {{ movements.filter(x => x.operation === 'forklift__receivedDirty' && x.type === stock.type).reduce((sum, element) => sum + element.num_crates, 0) }}
                </b-field>
                <b-field label="Received Clean">
                  {{ movements.filter(x => x.operation === 'forklift__receivedClean' && x.type === stock.type).reduce((sum, element) => sum + element.num_crates, 0) }}
                </b-field>
                <b-field label="Received to Repair">
                  {{ movements.filter(x => x.operation === 'forklift__receivedRepair' && x.type === stock.type).reduce((sum, element) => sum + element.num_crates, 0) }}
                </b-field>
              </b-field>
              <b-field grouped>
                <b-field label="Delivered Dirty">
                  {{ movements.filter(x => (x.operation === 'forklift__deliveredDirty') && x.type === stock.type).reduce((sum, element) => sum + element.num_crates, 0) }}
                </b-field>
                <b-field label="Delivered Clean">
                  {{ movements.filter(x => x.operation === 'forklift__deliveredClean' && x.type === stock.type).reduce((sum, element) => sum + element.num_crates, 0) }}
                </b-field>
                <b-field label="Delivered to Repair">
                  {{ movements.filter(x => x.operation === 'forklift__deliveredRepair' && x.type === stock.type).reduce((sum, element) => sum + element.num_crates, 0) }}
                </b-field>
              </b-field>
              <b-field grouped>
                <b-field label="Washed">
                  {{ movements.filter(x => { return ((x.operation === 'washing' || x.operation === 'machineWash') && x.type === stock.type) }).reduce((sum, element) => sum + element.num_crates, 0) }}
                </b-field>
                <b-field label="Repaired">
                  {{ movements.filter(x => (x.operation === 'repair') && x.type === stock.type).reduce((sum, element) => sum + element.num_crates, 0) }}
                </b-field>
                <b-field label="Rejected">
                  {{ movements.filter(x => x.operation === 'forklift__cleanRejectedDirty' || x.operation === 'forklift__cleanRejectedRepair').reduce((sum, element) => sum + element.num_crates, 0) }}
                </b-field>
              </b-field>
              <b-field grouped>
                <b-field label="Doors Repaired">
                  {{ movements.filter(x => x.operation === 'repair__door').reduce((sum, element) => sum + element.num_crates, 0) }}
                </b-field>
              </b-field>
            </b-tab-item>
          </b-tabs>
          <!-- <ag-grid-vue
            v-if="stocks.length != 0"
            style="width: 100%; height: 700px;"
            class="ag-theme-balham"
            :row-data="stocks"
            :grid-options="gridOptions"
            :pagination="true"
            :pagination-auto-page-size="true"
            :side-bar="['columns']"
            :cache-overflow-size="0"
            :multi-sort-key="'ctrl'"
            :modules="modules"
            :get-context-menu-items="getContextMenuItems"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AllModules } from '@ag-grid-enterprise/all-modules'
import { mapState } from 'vuex'
import Plant from '../../services/v2/plant'
import CrateMovements from '../../services/v3/crateMovements'
import Stock from '../../services/v3/crateStock'
// import sortAndFilterMixins from '@/mixins/agGridSortAndFilter'

export default {
  name: 'CrateStock',
  components: {
  },
  data: function () {
    return {
      date: new Date(),
      isLoading: false,
      activeTab: '5.2',
      selectedPlant: JSON.parse(sessionStorage.getItem('consultingPlant')),
      plants: [],
      stocks: [],
      crateStocks: [],
      movements: [],
      modules: AllModules,
      gridOptions: {
        cacheBlockSize: 20,
        paginationPageSize: 20,
        enableRangeSelection: true,
        defaultColDef: {
          floatingFilter: true,
          enableValue: true,
          enableRowGroup: true,
          enablePivot: false,
          resizable: true
        },
        columnDefs: [
          { headerName: 'Crates',
            field: 'num_crates',
            filter: 'agTextColumnFilter',
            width: 130,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Crate Type',
            field: 'type',
            filter: 'agTextColumnFilter',
            width: 130,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Status',
            field: 'status_crates',
            filter: 'agTextColumnFilter',
            width: 130,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted: async function () {
    if (this.user.group.plants.length === 0) {
      this.plants = await Plant.getAll()
    }
  },
  methods: {
    resetData () {
      this.stocks = []
    },
    async getData () {
      sessionStorage.setItem('consultingPlant', JSON.stringify(this.selectedPlant))
      this.isLoading = true
      this.stocks = []
      this.crateStocks = []
      this.movements = []
      this.$buefy.toast.open({ message: 'Loading Data', duration: 10000, type: 'is-success' })
      try {
        const data = await Stock.get({
          date: this.date.toLocaleDateString('en-CA'),
          statuses: ['5.2__DIRTY', '5.2__CLEAN', '5.2__REPAIR', '5.1__DIRTY', '5.1__CLEAN', '5.1__REPAIR', '5.5__DIRTY', '5.5__CLEAN', '5.5__REPAIR', '1__DIRTY', '1__CLEAN', '1__REPAIR', 'FOOD__DIRTY', 'FOOD__CLEAN', 'FOOD__REPAIR', 'ZEON__DIRTY', 'ZEON__CLEAN', 'ZEON__REPAIR', 'RHODIA__DIRTY', 'RHODIA__CLEAN', 'RHODIA__REPAIR'],
          siteId: this.selectedPlant.id
        })
        let types = ['1', '5.1', '5.2', '5.5']
        if (data.siteData && data.siteData.length > 0) {
          types = JSON.parse(data.siteData[0]?.types).map(x => x.name)
        }
        if (!(types && types.length > 0)) {
          types = ['1', '5.1', '5.2', '5.5']
        }
        data.stocks.forEach((element, index) => {
          this.stocks.push({
            id: index,
            num_crates: element.num_crates,
            type: element.status.split('__')[0],
            status_crates: element.status.split('__')[1]
          })
        })
        const data2 = await CrateMovements.getTable({
          start: this.date.toLocaleDateString('en-CA'),
          end: this.date.toLocaleDateString('en-CA'),
          siteId: this.selectedPlant.id
        })
        data2.forEach(element => {
          this.movements.push({
            operation: element.operation,
            num_crates: element.num_crates,
            status_crate_start: element.status_crate_start,
            status_crate_end: element.status_crate_end,
            type: element.status_crate_end.split('__')[0],
            shift: element.shift,
            date: new Date(element.date.split('Z')[0]).toLocaleDateString('en-CA'),
            comment: element.comment
          })
        })
        if (this.stocks.length > 0) {
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.$buefy.toast.open({ message: 'Error loading stocks', duration: 3000, type: 'is-danger' })
        }

        types.forEach(element => {
          this.crateStocks.push({
            type: element,
            stocks: this.stocks.filter(x => x.type === element)
          })
        })
        this.activeTab = types[0]
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
      this.isLoading = false
    },
    getContextMenuItems (params) {
      let customMenu = []
      const genericMenu = [
        'separator',
        'copy',
        'copyWithHeaders',
        'separator',
        'export'
      ]
      const result = [...customMenu, ...genericMenu]
      return result
    }
  }
}

</script>
